import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as routes from "../../../Router/RoutesURL";
import * as moment from 'moment';
import { createNotification } from '../../../Config/NotificationToast';
import Select from "react-select";
import AppContainer from '../../../components/AppContainer/AppContainer';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import { viewActivityDetails } from '../../../redux/actions/MasterDataAction/ActivityAction/ActivityAction';
import './ViewActivity.scss';
import { CircularProgress } from '@mui/material';
import ViewChildActivityTable from './ViewChildActivityTable';
import RadioButton from '../../../components/RadioButton/RadioButton';

const headCells = [
    {
        id: 'title',
        disablePadding: true,
        label: 'ACTIVITY TITLE',
        sorting: true,
        width: '180px'
    },
    {
        id: 'no_of_capacity',
        disablePadding: false,
        label: 'CAPACITY',
        sorting: true,
        width: '180px'
    },
    {
        id: 'booked_user',
        disablePadding: false,
        label: 'BOOKED USER COUNT',
        sorting: true,
        width: '180px'
    },
    {
        id: 'venue',
        disablePadding: false,
        label: 'VENUE',
        sorting: true,
        width: '180px'
    },
    {
        id: 'activity_datetime',
        disablePadding: false,
        label: 'ACTIVITY DATE',
        sorting: true,
        width: '180px'
    },
    {
        id: 'activity_time',
        disablePadding: false,
        label: 'ACTIVITY TIME',
        sorting: true,
        width: '180px'
    },
    {
        id: 'is_active',
        disablePadding: false,
        label: 'STATUS',
        sorting: true,
        width: '120px'
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        sorting: false,
        width: '220px'
    },
];


const ViewProgram = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [viewActivityMainData, setViewActivityMainData] = useState('');
    const [selectedStatus, setSelectedStatus] = useState();
    const [selectedActivityId, setSelectedActivityId] = useState("");
    const [activityTitle, setActivityTitle] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [repeatActivity, setRepeatActivity] = useState("");
    const [frequency, setFrequency] = useState(null);
    const [childActivity, setChildActivity] = useState({});


    const loading = useSelector(state => state?.viewActivityDetails.loading);
    const viewActivityDataRes = useSelector(state => state?.viewActivityDetails?.viewActivityDetails?.data);

    const options = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const { activityId, permission } = location.state;

    const handleFilter=(value)=>{
        if(value==='Completed'){
            let newData = viewActivityDataRes.child_activities?.filter(item=> new Date(item.activity_datetime)<new Date());
            newData.sort((a, b) => new Date(b.activity_datetime) - new Date(a.activity_datetime));
            setChildActivity({filter: value, data: newData})
        }else{
            let newData = viewActivityDataRes.child_activities?.filter(item=> new Date(item.activity_datetime)>new Date());
            newData.sort((a, b) => new Date(a.activity_datetime) - new Date(b.activity_datetime));
            setChildActivity({filter: value, data: newData})
        }
    }

    useEffect(() => {
        const sendRequest = {
            "activity_id": activityId
        };
        dispatch(viewActivityDetails(sendRequest));

        return(()=>{
            setViewActivityMainData('')
        })
    }, [location.state]);


    useEffect(() => {
        if(viewActivityDataRes && activityId===viewActivityDataRes?.id){
            setSelectedStatus(viewActivityDataRes && viewActivityDataRes?.is_active);
            setActivityTitle(viewActivityDataRes && viewActivityDataRes?.title);
            setSelectedActivityId(viewActivityDataRes && viewActivityDataRes?.id);
            setViewActivityMainData(viewActivityDataRes && viewActivityDataRes);
            setSelectedDate(moment(viewActivityDataRes?.activity_datetime).format('DD/MM/YYYY'));
            setSelectedTime(moment(viewActivityDataRes?.activity_datetime).format('HH:mm:ss'));
            setRepeatActivity(viewActivityDataRes?.is_repeated)
            setFrequency(viewActivityDataRes && viewActivityDataRes?.frequency && JSON.parse(viewActivityDataRes?.frequency))
            let newData = viewActivityDataRes?.child_activities
            newData?.sort((a, b) => new Date(a.activity_datetime) - new Date(b.activity_datetime));
            setChildActivity({filter: 'All', data: newData})
        }

    }, [viewActivityDataRes])


    const handleChangeOption = (e, id) => {
        if(permission === "write"){
        setSelectedStatus(e.value === "Active" ? 1 : 0);
        if (e.value === "Active") {
            setViewActivityMainData(viewActivityMainData.is_active = 1)
        } else {
            setViewActivityMainData(viewActivityMainData.is_active = 0)
        }
        setViewActivityMainData(viewActivityMainData)
        const sendRequest = {
            "feature_type": "daily_activity",
            "id": id,
            "status": e.value === "Active" ? 1 : 0
        };
        dispatch(updateIsActiveStatus(sendRequest));
        }else{
            createNotification('warning', "Access Restricted");
        }
    }

    const handleViewGuestList = () => {
        if (viewActivityDataRes && activityId) {
            localStorage.setItem("viewProgramTitle", JSON.stringify(activityTitle));
            navigate(routes.VIEW_INTERESTED_GUEST_LIST_ACTIVITY, { state: { selectedActivityId, activityTitle } })
        }
    };

    return (
        <AppContainer key={activityId} >
            <div className="event-content">
                <div className='ViewActivity mb-3'>
                    {
                        loading || !viewActivityMainData ?
                        <div className='loader'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                    :
                    <div className="card">
                        <div className="card-header">
                            <h4 className='activityTitle'>{viewActivityMainData.title}</h4>
                            <div className=' d-flex'>
                                <div>
                                    <Select
                                        className={viewActivityMainData.is_active === 1 ? "react-select" : "react-selectChange"}
                                        classNamePrefix="react-select"
                                        onChange={(e) => { handleChangeOption(e, viewActivityMainData.id) }}
                                        value={selectedStatus === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                        isSearchable={false}
                                        options={options}
                                        theme={(theme) => ({
                                            ...theme,
                                            isFocused: "#74613C",
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#F5F5F5',
                                                primary: '#f6f4f0',

                                            },
                                        })}
                                        getOptionLabel={(row) => (
                                            <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                            >
                                                {row.label}
                                            </span>
                                                {row.status === 1 && (
                                                    <div

                                                    ></div>
                                                )}
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-3">
                            <div className='row mb-3'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> ACTIVITY TITLE: </div>
                                        <div className='col-9'>{viewActivityMainData.title}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> VENUE: </div>
                                        <div className='col-9'>{viewActivityMainData.venue}</div>
                                    </div>
                                </div>
                            </div>
                            {
                                (viewActivityMainData.is_repeated==="0" || viewActivityMainData.repeat_ref_id) &&
                                <div className='row mb-3'>
                                    <div className='col-6'>
                                        <div className='row'>
                                            <div className='col-3 title'> CAPACITY: </div>
                                            <div className='col-9'>{viewActivityMainData.no_of_capacity}</div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='row'>
                                            <div className='col-3 title'> BOOKED USER: </div>
                                            <div className='col-9'>{viewActivityMainData.booked_user}{viewActivityMainData.booked_user>0 && <span className="viewLink" onClick={() => { handleViewGuestList() }}>View Guest List</span>}</div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='row mb-3'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> ACTIVITY DATE: </div>
                                        <div className='col-9'>{selectedDate? selectedDate: "-"}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> STOP DATE: </div>
                                        <div className='col-9'>{viewActivityMainData?.stop_activity_date ? moment(viewActivityMainData?.stop_activity_date).format('DD/MM/YYYY'): '-'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> REPEAT ACTIVITY: </div>
                                        <div className='col-9'>{viewActivityMainData?.is_repeated === '1' ? "Yes" : "No"}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='row'>
                                        {
                                            viewActivityMainData?.is_repeated === '1'&&
                                            <>
                                                <div className='col-3 title'> FREQUENCY: </div>
                                                <div className='col-9 text-capitalize'>
                                                    {frequency?.key} &nbsp;
                                                    {
                                                        frequency?.key === "weekly"
                                                        ?
                                                        <>
                                                            
                                                            {
                                                                frequency?.value.map((item, index)=>(
                                                                    <React.Fragment key={index}>
                                                                        {item.value ? <span className='chip text-capitalize rounded-pill p-2 py-1 mr-2  bg-light' style={{color:'#74613C'}}>{item.day}</span> : null}
                                                                        {item.value && index !== frequency?.value.length-1 ? " " : null}
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> TIME: </div>
                                        <div className='col-9'>{selectedTime}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                <div className='row'>
                                        <div className='col-3 title'> DURATION: </div>
                                        <div className='col-9'>{viewActivityMainData.duration} Minutes</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-6'>
                                    <div className='row'>
                                        <div className='col-3 title'> NOTES: </div>
                                        <div className='col-9' style={{whiteSpace: 'pre-wrap'}}>{viewActivityMainData.notes}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            viewActivityMainData?.is_repeated ==='1' &&
                            <>
                                <hr className='mt-3'/>
                                <div className='d-flex my-2 ml-2 filters'> 
                                    <RadioButton onChange={handleFilter} name={'filter'} checked={childActivity.filter==='All'} value={'All'} label={'All'} />
                                    <RadioButton onChange={handleFilter} name={'filter'} checked={childActivity.filter==='Upcoming'} value={'Upcoming'} label={'Upcoming'} />
                                    <RadioButton onChange={handleFilter} name={'filter'} checked={childActivity.filter==='Completed'} value={'Completed'} label={'Completed'} />
                                </div>
                                <ViewChildActivityTable
                                    checkbox={false}
                                    columns={headCells}
                                    data ={[
                                        {
                                            title: viewActivityMainData.title,
                                            no_of_capacity: viewActivityMainData.no_of_capacity,
                                            booked_user: viewActivityMainData.booked_user,
                                            id: viewActivityMainData.id,
                                            venue: viewActivityMainData.venue,
                                            activity_datetime: selectedDate,
                                            activity_time: selectedTime,
                                            is_active: viewActivityMainData.is_active,
                                            is_active: viewActivityMainData.is_active,
                                            isParent: true
                                        },
                                        ...(childActivity.data?.map(item=>({...item, activity_datetime: moment(item.activity_datetime)?.format('DD/MM/YYYY'), activity_time: moment(item.activity_datetime)?.format('HH:mm:ss')})) || [])
                                    ]}
                                //     pagination={data.queryReport?.list?.length}
                                //     totalCount={data.queryReport?.total}
                                //     totalPages={data.queryReport?.total_pages}
                                //     start={(data.queryReport?.current_page_no - 1) * (data.queryReport?.end-data.queryReport?.start) + 1}
                                //     end={(data.queryReport?.current_page_no - 1) * (data.queryReport?.end-data.queryReport?.start) + data.queryReport?.list?.length}
                                />
                            </>
                        }
                    </div >}
                </div>
            </div >
        </AppContainer >
    )
}

export default ViewProgram
